<template>
  <div class="q-pa-md sai-print-avoid-break-inside">
    <span class="text-title text-weight-bold text-capitalize">
      {{ frequency }} Savings Summary
    </span>
    <QSeparator class="q-my-md" />
    <div class="q-gutter-y-sm column q-mb-xs">
      <div
        v-for="(row, index) in rows"
        :key="index"
        :class="[
          'row items-center q-gutter-x-sm',
          { 'text-weight-medium': row.bold }
        ]"
      >
        <span :class="['text-grey-6', { 'text-grey-10': row.bold }]">
          {{ row.label }}
        </span>
        <SAIInformationPopup v-if="row.information" icon-color="application">
          <p>{{ row.information }}</p>
        </SAIInformationPopup>
        <QSpace />
        <span v-if="row.negative" class="text-title text-negative">-</span>
        <span
          :class="[
            'text-paragraph text-grey-8 text-weight-medium',
            { 'text-grey-10': row.bold }
          ]"
        >
          {{ row.value | frequency('monthly', frequency) | currency }}
        </span>
      </div>
    </div>
    <div class="q-mt-sm row">
      <span class="text-paragraph text-primary text-weight-medium">
        Net Income
      </span>
      <QSpace />
      <span class="text-paragraph text-primary text-weight-medium">
        {{ netIncome | frequency('monthly', frequency) | currency }}
      </span>
    </div>
  </div>
</template>

<script>
import { QSeparator, QSpace } from 'quasar';
import { SAIInformationPopup } from 'ecx.saigon.ui.common';

export default {
  name: 'LeaseSummary',
  props: {
    grossSalary: Number,
    preTaxDeduction: Number,
    netTaxableIncome: Number,
    incomeTax: Number,
    fbtTaxExemption: Boolean,
    postTaxDeduction: Number,
    netIncome: Number,
    frequency: {
      type: String,
      default: 'yearly'
    }
  },
  computed: {
    rows() {
      return [
        {
          label: 'Gross Salary',
          value: this.grossSalary
        },
        {
          label: 'Pre-Tax Deductions',
          information:
            'This is your lease cost taken out of your salary before tax.',
          value: this.preTaxDeduction,
          negative: true
        },
        {
          label: 'Net Taxable Income.',
          value: this.netTaxableIncome,
          bold: true
        },
        {
          label: 'Income Tax (inc. Medicare).',
          value: this.incomeTax,
          negative: true
        },
        {
          label: `Post-Tax Deductions${
            this.fbtTaxExemption ? ' (FBT exempt)' : ''
          }`,
          value: this.postTaxDeduction,
          information:
            'A novated lease attracts Fringe Benefits Tax (FBT). We use the Employee Contribution Method (ECM) to help negate any FBT liability you may incur, by making a post-tax deduction. This contributes to the total package cost.',
          negative: !this.fbtTaxExemption
        }
      ];
    }
  },
  components: {
    QSeparator,
    QSpace,
    SAIInformationPopup
  }
};
</script>
